
const digest = '716d5dd364f4dbfbed532fc2b8ba7455b03f16f038cfbb6800a4137234c817ae';
const classes = {"wrapper":"_wrapper_stit1_2","left":"_left_stit1_9","right":"_right_stit1_17","header":"_header_stit1_24","title":"_title_stit1_34","actions":"_actions_stit1_38","wizardKey":"_wizardKey_stit1_45","button":"_button_stit1_48","editor":"_editor_stit1_55","statusBar":"_statusBar_stit1_60","previewHeader":"_previewHeader_stit1_66","previewBody":"_previewBody_stit1_72","previewJson":"_previewJson_stit1_82","previewInvalid":"_previewInvalid_stit1_88","addWrap":"_addWrap_stit1_110","addMenu":"_addMenu_stit1_115"};
const css = `@charset "UTF-8";
._wrapper_stit1_2 {
  display: flex;
  height: 100%;
  min-height: 0;
  gap: 20px;
}

._left_stit1_9 {
  flex: 2;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

._right_stit1_17 {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

._header_stit1_24 {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

._title_stit1_34 {
  font-weight: 700;
}

._actions_stit1_38 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
  flex: 1;
}
._actions_stit1_38 ._wizardKey_stit1_45 {
  display: flex;
}
._actions_stit1_38 ._button_stit1_48 {
  background: #ffffff;
}
._actions_stit1_38 ._button_stit1_48:hover {
  background: #dfdfdf;
}

._editor_stit1_55 {
  flex: 1;
  min-height: 0;
}

._statusBar_stit1_60 {
  padding: 8px 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 12px;
}

._previewHeader_stit1_66 {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-weight: 700;
}

._previewBody_stit1_72 {
  overflow: auto;
  flex: 1;
  min-height: 0;
  background-color: red;
  border-radius: 15px;
  padding: 24px;
  overflow-y: scroll;
}

._previewJson_stit1_82 {
  font-family: monospace;
  font-size: 12px;
  white-space: pre-wrap;
}

._previewInvalid_stit1_88 {
  font-size: 13px;
  opacity: 0.8;
}

/* Optional: sjednocené button styly (jestli chceš) */
._actions_stit1_38 button {
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: transparent;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
}

._actions_stit1_38 button:hover {
  background: rgba(0, 0, 0, 0.04);
}

._actions_stit1_38 button:active {
  transform: translateY(1px);
}

._addWrap_stit1_110 {
  position: relative;
  display: inline-flex;
}

._addMenu_stit1_115 {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  min-width: 180px;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

._addMenu_stit1_115 button {
  text-align: left;
  padding: 8px 10px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
}

._addMenu_stit1_115 button:hover {
  background: rgba(0, 0, 0, 0.06);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  